import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface SpeedChipProps {
  speed: number;
  onClick: () => void;
  /** 'accent' = sits on a green (caller) bubble; otherwise follows the theme. */
  surface: 'accent' | 'light' | 'dark';
}

/**
 * Playback-speed pill: fixed width so the layout never jumps, a hairline ring,
 * and the number rolls vertically when it changes. Faster than 1× switches to
 * a solid filled state so a sped-up recording is noticeable at a glance.
 */
export function SpeedChip({
  speed,
  onClick,
  surface
}: SpeedChipProps) {
  const boosted = speed !== 1;
  const styles = {
    accent: boosted ? 'bg-white text-vexu-700 ring-white shadow-[0_1px_3px_rgba(0,0,0,0.12)]' : 'bg-white/[0.14] text-white ring-white/30 hover:bg-white/20',
    light: boosted ? 'bg-vexu text-white ring-vexu shadow-[0_1px_3px_rgba(0,200,83,0.35)]' : 'bg-white text-slate-700 ring-slate-200 shadow-[0_1px_2px_rgba(15,23,42,0.06)] hover:ring-slate-300',
    dark: boosted ? 'bg-vexu text-white ring-vexu shadow-[0_1px_3px_rgba(0,200,83,0.3)]' : 'bg-white/[0.06] text-zinc-100 ring-white/15 hover:bg-white/10'
  }[surface];
  return <motion.button type="button" data-voice-control onClick={onClick} whileTap={{
    scale: 0.9
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} aria-label={`Playback speed ${speed}×, tap to change`} className={`relative inline-flex h-[22px] w-[38px] flex-shrink-0 items-center justify-center overflow-hidden rounded-full ring-1 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-vexu ${styles}`} data-id="element-418" data-mp="1n0s56xts4azu">
      <AnimatePresence mode="popLayout" initial={false} data-id="element-419" data-mp="zbfws06a06yl">
        <motion.span key={speed} initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -10,
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-baseline tabular-nums" data-id="element-420" data-mp="z9wek4127lu6">
          <span className="text-[11px] font-bold tracking-[-0.02em]" data-id="element-421" data-mp="26ohxpuw4s1i1">
            {speed}
          </span>
          <span className="ml-[1px] text-[9px] font-semibold opacity-70" data-id="element-422" data-mp="2blruxwprhhgf">
            ×
          </span>
        </motion.span>
      </AnimatePresence>
    </motion.button>;
}